export default __webpack_public_path__ + "static/scientist1-fb74a41a80c284f1c9897059825d8bd8.png";